import { Text } from '@capsicum/common-web';
import { getFormattedDateTime } from '@capsicum/features/wallet/shared';

export const DateTimeField = ({ value }: { value: string }) => {
	return <Text variant="text1">{getFormattedDateTime(value)}</Text>;
};
